import { defineStore } from "pinia";
export const useDefaultStore = defineStore({
  persist: true,
  id: "defaultStore",
  state: () => ({
    courseThumbnail: require("@/assets/default-thumbnail.jpg"),
  }),
});
